jQuery(function ($) {

	class MatatPandoraProductSuggestionSlider {

		constructor() {
			this.init();
		}

		/**
		 * Initialize offcanvas, sliders, and event bindings
		 */
		init() {
			this.initSliders();

			// Toggle off-canvas suggestion panel
			$(document.body).on("click", ".offcanvas-suggestion-highlight", this.toggleOffCanvas.bind(this));

			// Open product quick view
			$(document.body).on("click", ".shop-thelook-product", this.openQuickView.bind(this));

			// Close quick view (both close buttons)
			$(document.body).on("click", ".micromodal .pandora-quick-view-close", this.closeQuickView.bind(this));
			$(document.body).on("click", ".micromodal .pandora-quick-popup-close", this.closeQuickView.bind(this));

			// Close modal when clicking outside modal-main-wrapper
			$(document).on("click", this.outsideModalClick.bind(this));

			$(document.body).on('click', '.accordion-header', this.toggleAccordion.bind(this));

			// Tab switching for shop the look modal
			$(document.body).on("click", ".shop-thelook-product-tab-item", this.switchTab.bind(this));

			// Recalculate scrollable state on window resize
			$(window).on('resize', this.debounce(() => {
				$('.micromodal.open-model').each((_, modal) => {
					this.checkModalScrollable($(modal));
				});
			}, 100));
		}

		/**
		 * Debounce utility function
		 */
		debounce(func, wait) {
			let timeout;
			return function executedFunction(...args) {
				const later = () => {
					clearTimeout(timeout);
					func(...args);
				};
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
			};
		}

		/**
		 * Check if modal wrapper is taller than screen and add is-scrollable class
		 * Works for all micromodals
		 */
		checkModalScrollable($modal) {
			const $modalWrapper = $modal.find('.modal-main-wrapper');
			if (!$modalWrapper.length) {
				return;
			}

			// Get screen height and modal wrapper height
			const screenHeight = $(window).height();
			const modalWrapperHeight = $modalWrapper.outerHeight();

			// Add or remove is-scrollable class based on comparison
			if (screenHeight < modalWrapperHeight) {
				$modal.addClass('is-scrollable');
			} else {
				$modal.removeClass('is-scrollable');
			}
		}

		/**
		 * Switch tab in shop the look modal
		 */
		switchTab(e) {
			e.preventDefault();
			const $tab = $(e.currentTarget);

			// Skip if inside minicart trigger - handled by minicart-sale-notification.js
			if ($tab.closest('.minicart-stl-trigger').length) {
				return;
			}

			const targetId = $tab.attr('data-productref');

			// Remove active from sibling tabs
			$tab.siblings('.shop-thelook-product-tab-item').removeClass('active');
			$tab.addClass('active');

			// Find the modal wrapper and switch content
			const $modalWrapper = $tab.closest('.modal-main-wrapper');
			if ($modalWrapper.length) {
				$modalWrapper.find('.shop-thelook-product-tab-content').removeClass('active');
				$modalWrapper.find('#' + targetId).addClass('active');
			}
		}

		/**
		 * Close Quick View
		 */
		closeQuickView(e) {
			e.preventDefault();
			let __this = $(e.currentTarget);
			__this.parents('.micromodal').removeClass('open-model');
			// __this.parents('.micromodal').find('#modal-content').html('');
		}

		/**
		 * Close modal if clicked outside modal-main-wrapper
		 */
		outsideModalClick(e) {
			const $modal = $('.micromodal.open-model');
			if (!$modal.length) return;

			// Ignore clicks inside the modal content
			if (
				!$(e.target).closest('.modal-main-wrapper').length &&
				!$(e.target).closest('.shop-thelook-product').length
			) {
				$modal.removeClass('open-model');
				// $modal.find('#modal-content').html('');
			}
		}

		/**
		 * Open Quick View
		 */
		openQuickView(e) {
			e.preventDefault();

			let _this = this,
				__this = $(e.currentTarget),
				productId = __this.data('product_id');

			// Skip if inside minicart trigger - handled by minicart-sale-notification.js
			if (__this.closest('.minicart-stl-trigger').length) {
				return;
			}

			if (!productId) {
				console.log('Product ID is missing.');
				return;
			}

			// add class show-loader to body
			$('body').addClass('show-loader');

			$.ajax({
				type: 'POST',
				url: woocommerce_params.ajax_url,
				data: {
					action: 'pandora_load_quick_view',
					product_id: productId,
					security: mpParams.nonce,
				},
				beforeSend: () => {
					__this.addClass('pandora-loading');
				},
				success: (response) => {
					if (response.success) {
						// find the parent .shop-thelook-panel-inner
						const $shopTheLookPanelInner = __this.parents('.shop-thelook-panel-inner');

						$shopTheLookPanelInner.find('.micromodal').addClass('open-model');
						$shopTheLookPanelInner.find('.micromodal #modal-content').html(response.data.html);

						// Small delay to ensure DOM is fully updated before initializing WooCommerce
						setTimeout(() => {
							// Use the new PandoraQuickSwatch class if available
							if (typeof window.PandoraQuickSwatch !== 'undefined') {
								window.PandoraQuickSwatch.init($shopTheLookPanelInner);
							} else {
								// Fallback to old method
								this.initWooCommerceVariations($shopTheLookPanelInner);
							}
						}, 50);

						$(document.body).trigger('refresh_video_stream');
						_this.initMobile_Quickview_SLider();
					} else {
						console.log('Quick View error:', response.data.message);
					}
				},
				error: () => {
					console.log('Error loading Quick View.');
				},
				complete: () => {
					$('body').removeClass('show-loader');
					__this.removeClass('pandora-loading');
				}
			});
		}

		/**
		 * Mobile Quick View Slider
		 * This function is used to open the quick view slider on mobile devices.
		 */
		initMobile_Quickview_SLider() {
			new Swiper(".micromodal #modal-content .pandora-quick-view-slider", {
				loop: true,
				speed: 500,
				effect: 'slide',
				centeredSlides: true,
				grabCursor: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				}
			});
		}

		/**
		 * Toggle Off-Canvas Suggestion Panel
		 */
		toggleOffCanvas(e) {
			e.preventDefault();
			const $highlightBtn = $(e.currentTarget);

			// Skip if inside minicart trigger - handled by minicart-sale-notification.js
			if ($highlightBtn.closest('.minicart-stl-trigger').length) {
				return;
			}

			if ($highlightBtn.length) {
				const $shopTheLookPopup = $highlightBtn.closest('.shop-thelook-block');
				if ($shopTheLookPopup.length) {
					const $modal = $shopTheLookPopup.find('.pandora-shop-the-look-popup .modal');
					setTimeout(() => {
						if ($modal.length) {
							$($modal).addClass('open-model');
							if ($(window).width() <= 1280) {
								// initialize mobile quick view slider
								this.initMobile_Quickview_SLider();
							}
							// Check if modal needs scrollable class
							this.checkModalScrollable($modal);
						}
					}, 100);
				}
			}
		}

		/**
		 * Initialize WooCommerce variation forms for dynamically loaded content
		 */
		initWooCommerceVariations($container) {
			// Find and initialize variation forms
			const $variationForms = $container.find('.variations_form');

			if ($variationForms.length > 0) {
				$variationForms.each(function () {
					const $form = $(this);

					// Remove any existing variation form instances to prevent conflicts
					if ($form.data('wc-variation-form')) {
						try {
							$form.data('wc-variation-form').destroy();
						} catch (e) {
							console.log('Error destroying existing variation form:', e);
						}
					}

					// Ensure WooCommerce variation script is available
					if (typeof $.fn.wc_variation_form !== 'undefined') {
						// Initialize WooCommerce variation form
						$form.wc_variation_form();

						// Trigger variation check to update form state
						$form.trigger('check_variations');
						$form.trigger('woocommerce_variation_has_changed');
					} else {
						console.error('WooCommerce variation form script not loaded');
					}
				});

				// Initialize any other WooCommerce functionality
				this.initWooCommerceComponents($container);
			}
		}

		/**
		 * Initialize other WooCommerce components for dynamically loaded content
		 */
		initWooCommerceComponents($container) {
			// Initialize quantity inputs
			$container.find('.qty').each(function () {
				const $qty = $(this);
				if (!$qty.data('quantity-initialized')) {
					$qty.data('quantity-initialized', true);
					// Add any quantity input handling if needed
				}
			});

			// Initialize any other WooCommerce components that might be needed
			if (typeof $.fn.prettyPhoto !== 'undefined') {
				$container.find('a[data-rel^="prettyPhoto"]').prettyPhoto();
			}
		}

		/**
		 * Initialize Swiper sliders
		 */
		initSliders() {
			$('.shop-thelook-slider.swiper.pandora-swiper-view').each(function () {
				const $slider = $(this);
				const optionsAttr = $slider.attr('data-swiper-options');

				if (!optionsAttr) return;

				let options;
				try {
					options = JSON.parse(optionsAttr);
				} catch (e) {
					console.error('Invalid Swiper options JSON:', e);
					return;
				}

				new Swiper(this, {
					loop: !!options.loop,
					speed: options.speed || 500,
					effect: options.effect || 'slide',
					centeredSlides: !!options.centeredSlides,
					grabCursor: !!options.grabCursor,
					autoplay: options.autoplay
						? {
							delay: options.autoplayDelay || 3000,
							disableOnInteraction: false
						}
						: false,
					navigation: options.showArrows
						? {
							nextEl: $slider.find('.swiper-button-next')[0],
							prevEl: $slider.find('.swiper-button-prev')[0]
						}
						: false,
					pagination: options.showDots
						? {
							el: $slider.find('.swiper-pagination')[0],
							clickable: true
						}
						: false,
					breakpoints: {
						0: {
							slidesPerView: options.slidesPerView?.mobile ?? 1,
							spaceBetween: options.spaceBetween?.mobile ?? 10
						},
						768: {
							slidesPerView: options.slidesPerView?.tablet ?? 2,
							spaceBetween: options.spaceBetween?.tablet ?? 10
						},
						1024: {
							slidesPerView: options.slidesPerView?.desktop ?? 4,
							spaceBetween: options.spaceBetween?.desktop ?? 10
						}
					}
				});
			});
		}

		/**
		 * Init accordian
		 */
		toggleAccordion(e) {
			e.preventDefault();

			const __this = $(e.currentTarget);
			const $item = __this.parent('.accordion-item');
			const $content = $item.find('.accordion-content');
			const $icons = __this.find('svg');

			const isOpen = $item.hasClass('active');

			// Optional: close all other items
			$item.siblings('.accordion-item').removeClass('active')
				.find('.accordion-content').slideUp()
				.end().find('svg').eq(0).show().end().eq(1).hide(); // plus show, minus hide

			// Toggle current item
			if (!isOpen) {
				$item.addClass('active');
				$content.slideDown();
				$icons.eq(0).hide();  // Hide plus
				$icons.eq(1).show();  // Show minus
			} else {
				$item.removeClass('active');
				$content.slideUp();
				$icons.eq(0).show();  // Show plus
				$icons.eq(1).hide();  // Hide minus
			}
		}
	}

	// Instantiate the class
	new MatatPandoraProductSuggestionSlider();

});


